/*  eslint-disable array-callback-return */
/* eslint-disable eqeqeq */

import Popper from "@material-ui/core/Popper";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import React from "react";
import { connect } from "react-redux";
import {
  addAttribute
} from "../../../../Actions/Form";

const AccessOverview = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const closePopper = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
      <div onMouseLeave={closePopper}>
        <React.Fragment>
          {props.form.selectedAccess &&
            props.form.selectedAccess.ID === props.data.ID && (
              <Popper open={open} anchorEl={anchorEl}>
                <div
                  className="menu-container"
                  onMouseLeave={() => closePopper(false)}
                  style={{
                    marginLeft: "-175px",
                    marginTop: "0px",
                    cursor: "pointer",
                  }}
                >
                  <div
                    className="menu-options"
                    onClick={() => {
                      closePopper("bottom-end");
                      props.showAddAccess(props.data);
                    }}
                  >
                    {props.form.language.EDIT}
                  </div>
                  <div
                    className="menu-options"
                    onClick={() => {
                      closePopper("bottom-end");
                      props.handleRequest("delete", props.data.ID);
                      props.addAttribute({
                        name: "selectedAccess",
                        value: {},
                      });
                    }}
                  >
                    {props.form.language.DELETE}
                  </div>
                </div>
              </Popper>
            )}
        </React.Fragment>

        <div className="overviewContainer">
          <div
            className="overviewMenu"
            onClick={(event) => {
              handleClick(event);
              props.addAttribute({
                name: "selectedAccess",
                value: props.data,
              });
            }}
          >
            <MoreHorizIcon className='show-menu-icon' />
          </div>
          <div
            className="momentio-text-bold"
            style={{ marginTop: "-5px", width: "100%" }}
          >
            <div style={{ display: "flex" }}  className="input-container-column">
              <div className="momentio-text-normal accordion-content-option-label">
                {props.form.language.DESCRIPTION_LABEL}
              </div>
              <div className="momentio-text-bold" style={{ width: "70%" }}>
                {props.data.remark}
              </div>
            </div>
            <div style={{ display: "flex" }}  className="input-container-column">
              <div className="momentio-text-normal accordion-content-option-label">
                {props.form.language.LOCATION_LABEL}
              </div>
              <div className="momentio-text-bold" style={{ width: "70%" }}>
                {props.data.location}
              </div>
            </div>
            <div style={{ display: "flex" }}  className="input-container-column">
              <div className="momentio-text-normal accordion-content-option-label">
                {props.form.language.CONTACT_PERSON_TITLE}
              </div>
              <div className="momentio-text-bold" style={{ width: "70%" }}>
                {props.contactList?.map((contact) => {
                    if (contact.system.id == props.data.accessContactID?.replaceAll(";", "")) {
                      return (
                        <span key={`contact${contact.system.id}`}>
                          {contact.privateData.firstName + " " + contact.privateData.lastName}
                        </span>
                      );
                    }
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return { ...state };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addAttribute: (payload) => dispatch(addAttribute(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AccessOverview);
